import { createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { decryptRole } from "App";
import ApiClient from "helpers/ApiClient";
import { getToken } from "helpers/Tokens";

const initialState: any = {
  calanderEvents: [],
  status:'pending',
};

// get calander events 
export const getCalanderEvents:any = createAsyncThunk<any>(
  "calanders/getCalanderEvents",
  async (payload:any, thunkAPI) => {
    let userData= getToken()
    let lawyerRole = decryptRole(userData?.role)==='Lawyers'
    
    const paramsObj: any = {
      limit:5000,
    }
    if(!lawyerRole) paramsObj['userId'] = userData?.id
    if(lawyerRole) paramsObj['lawyerId'] = userData?.id
    if(payload) { paramsObj.eventType = payload;}
    try {
      const query = '?' + new URLSearchParams(paramsObj).toString();
      const response:any = await ApiClient.get(`calendar${query}`);
      return response?.data?.events;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error); 
    }
  }
);

const calanderSlice = createSlice({
  name: "calanders",
  initialState,
  reducers: {
    setCalanderEvents(state, action) {
      state.calanderEvents = action.payload;
    },
  },
  extraReducers:(builder) => {
    builder
    // get All Calander events 
    .addCase(getCalanderEvents.pending, (state:any) => {
      state.status = 'pending'
    })
    .addCase(getCalanderEvents.fulfilled, (state:any, action: any) => {
      state.status = 'success'
      state.calanderEvents = action.payload;
    })
    .addCase(getCalanderEvents.rejected, (state:any) => {
      state.status = 'reject'
    })
  }, 
});

export const { setCalanderEvents } = calanderSlice.actions
export default calanderSlice;
